import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const CollapseStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "collapse-styled",
})`
  .CollapseStyled--border {
    border-bottom: 1px solid ${greyMui._300};
  }

  .Collapse-Header {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 8px 16px;
  }

  .Collapse-Header-Inner {
    padding: 0;
    padding-inline-start: 0 !important;
  }

  .Collapse-Icon {
    margin-inline-start: auto;
    color: ${greyMui._600};
  }
`;
